/**
 * Minimalist Theme - Main JavaScript
 * A minimalist dark theme for Shopify streetwear stores
 */

(function () {
  'use strict';

  /**
   * ============================================
   * Intro Loader
   * ============================================
   */
  function initIntroLoader() {
    var loader = document.getElementById('bs-loader');
    if (!loader) return;

    // Click to skip
    loader.addEventListener('click', function () {
      loader.style.display = 'none';
      sessionStorage.setItem('bs_loader_seen', '1');
    });

    // Show only once per session
    if (sessionStorage.getItem('bs_loader_seen') === '1') {
      loader.style.display = 'none';
      return;
    }

    // Auto-hide after a short delay
    window.addEventListener('load', function () {
      setTimeout(function () {
        loader.style.opacity = '0';
        loader.style.transition = 'opacity 500ms ease';
        setTimeout(function () {
          loader.style.display = 'none';
          sessionStorage.setItem('bs_loader_seen', '1');
        }, 520);
      }, 900);
    });
  }

  /**
   * ============================================
   * Collection Header Time Display
   * ============================================
   */
  function initCollectionHeaderTime() {
    var root = document.querySelector('.bs-collection-header');
    if (!root) return;

    var tz = root.getAttribute('data-bs-tz') || 'America/Los_Angeles';
    var city = root.getAttribute('data-bs-city') || 'California';
    var el = root.querySelector('.bs-collection-header__time');
    if (!el) return;

    function pad2(n) {
      return String(n).padStart(2, '0');
    }

    function renderTime() {
      try {
        var parts = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        }).formatToParts(new Date());

        var map = {};
        for (var i = 0; i < parts.length; i++) {
          map[parts[i].type] = parts[i].value;
        }

        var mm = map.month || '';
        var dd = map.day || '';
        var yyyy = map.year || '';
        var hour = map.hour || '';
        var minute = map.minute || '';
        var dayPeriod = (map.dayPeriod || '').toLowerCase();

        el.textContent = mm + '/' + dd + '/' + yyyy + ' ' + hour + ':' + minute + dayPeriod + ' ' + city;
      } catch (e) {
        var d = new Date();
        el.textContent =
          pad2(d.getMonth() + 1) + '/' + pad2(d.getDate()) + '/' + d.getFullYear() + ' ' +
          pad2(d.getHours()) + ':' + pad2(d.getMinutes()) + ' ' + city;
      }
    }

    renderTime();
    setInterval(renderTime, 30000);
  }

  /**
   * ============================================
   * Countdown Timer
   * ============================================
   */
  function initCountdownTimer() {
    var countdown = document.getElementById('bs-countdown');
    if (!countdown) return;

    var targetDate = countdown.getAttribute('data-target');
    if (!targetDate) return;

    var target = new Date(targetDate).getTime();
    var timeEl = countdown.querySelector('.bs-countdown__time');

    function updateCountdown() {
      var now = new Date().getTime();
      var distance = target - now;

      if (distance < 0) {
        timeEl.textContent = '0d 0h 0m 0s';
        countdown.classList.add('zero');
        return;
      }

      countdown.classList.remove('zero');

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      timeEl.textContent = days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's';
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /**
   * ============================================
   * Deep-Cut Easter Eggs
   * ============================================
   */
  function initDeepCutEasterEggs() {
    var body = document.body;
    if (!body) return;

    var konami = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
    var konamiIndex = 0;
    var keyBuffer = '';
    var partyTimer = null;
    var rewardTimer = null;
    var activeRewardClass = '';
    var exclusiveCooldown = false;
    var exclusiveCooldownTimer = null;
    var logoClickCount = 0;
    var logoClickResetTimer = null;
    var storageKey = 'bs_deepcut_unlocks';

    var pageRewards = {
      about: {
        className: 'bs-reward-about',
        title: 'Archive room unlocked',
        message: 'The About page shifted into founder-journal mode for a moment.',
        hint: 'Try the tiny secret button too.',
        duration: 15000
      },
      contact: {
        className: 'bs-reward-contact',
        title: 'Hotline mode unlocked',
        message: 'Contact just switched to concierge priority styling.',
        hint: 'Typing "help" still reveals its own note.',
        duration: 15000
      },
      news: {
        className: 'bs-reward-news',
        title: 'Newswire mode unlocked',
        message: 'Dispatch cards now glow like a live feed.',
        hint: 'Use search + tags while this is active.',
        duration: 14000
      },
      media: {
        className: 'bs-reward-media',
        title: 'Studio mode unlocked',
        message: 'Media cards entered late-night editing energy.',
        hint: 'Hover each card for extra glow.',
        duration: 14000
      },
      services: {
        className: 'bs-reward-services',
        title: 'Pitch mode unlocked',
        message: 'Services is now in boardroom-ready highlight mode.',
        hint: 'This one stacks well with the logo sigil.',
        duration: 17000
      },
      giveaways: {
        className: 'bs-reward-giveaways',
        title: 'Lucky mode unlocked',
        message: 'Giveaway UI is now running on pure gremlin luck.',
        hint: 'You definitely did not see this in the docs.',
        duration: 14000
      },
      site: {
        className: 'bs-reward-site',
        title: 'Secret mode unlocked',
        message: 'You found the deep-cut layer hidden in plain sight.',
        hint: 'Every page has a different reward reaction.',
        duration: 13000
      }
    };

    var toast = document.createElement('div');
    toast.className = 'bs-secret-toast';

    var toastTitle = document.createElement('p');
    toastTitle.className = 'bs-secret-toast__title';
    toast.appendChild(toastTitle);

    var toastBody = document.createElement('p');
    toastBody.className = 'bs-secret-toast__body';
    toast.appendChild(toastBody);

    var toastHint = document.createElement('p');
    toastHint.className = 'bs-secret-toast__hint';
    toast.appendChild(toastHint);

    document.body.appendChild(toast);

    function getPageHandle() {
      var classNames = document.body.className ? document.body.className.split(/\s+/) : [];
      for (var i = 0; i < classNames.length; i++) {
        if (classNames[i].indexOf('page-handle-') === 0) {
          return classNames[i].replace('page-handle-', '');
        }
      }
      return 'site';
    }

    function getRewardConfig() {
      var handle = getPageHandle();
      if (pageRewards[handle]) {
        return pageRewards[handle];
      }
      return pageRewards.site;
    }

    function clearRewardState() {
      if (activeRewardClass) {
        body.classList.remove(activeRewardClass);
        activeRewardClass = '';
      }
      body.classList.remove('bs-lore-mode');
      body.classList.remove('bs-exclusive-mode');
    }

    function showToast(title, message, hint) {
      toastTitle.textContent = title;
      toastBody.textContent = message;
      toastHint.textContent = hint || '';

      toast.classList.add('is-visible');

      window.clearTimeout(showToast._timer);
      showToast._timer = window.setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 4200);
    }

    function incrementUnlockCount() {
      var nextCount = 1;
      try {
        var prior = Number(localStorage.getItem(storageKey) || '0');
        nextCount = prior + 1;
        localStorage.setItem(storageKey, String(nextCount));
      } catch (e) {
        nextCount = 1;
      }
      return nextCount;
    }

    function activateReward(triggerLabel, flavor) {
      var reward = getRewardConfig();
      var unlockCount = incrementUnlockCount();
      var duration = reward.duration || 14000;

      clearRewardState();

      activeRewardClass = reward.className;
      body.classList.add(activeRewardClass);

      if (flavor === 'lore') {
        body.classList.add('bs-lore-mode');
      }

      if (flavor === 'exclusive') {
        body.classList.add('bs-exclusive-mode');
        duration += 6000;
      }

      window.clearTimeout(rewardTimer);
      rewardTimer = window.setTimeout(function () {
        clearRewardState();
      }, duration);

      if (unlockCount % 3 === 0) {
        body.classList.add('bs-party-mode');
        window.clearTimeout(partyTimer);
        partyTimer = window.setTimeout(function () {
          body.classList.remove('bs-party-mode');
        }, 9000);
      }

      showToast(
        reward.title,
        reward.message,
        (flavor === 'exclusive' ? 'Page-exclusive unlock. ' : '') + reward.hint + ' Trigger: ' + triggerLabel + '.'
      );

      if (unlockCount > 0 && unlockCount % 5 === 0) {
        window.setTimeout(function () {
          showToast(
            'Achievement',
            'Curiosity level: elite. You have found ' + unlockCount + ' hidden interactions.',
            'You are officially the kind of user who reads changelogs for fun.'
          );
        }, 520);
      }
    }

    function activateExclusiveReward(triggerLabel) {
      if (exclusiveCooldown) return;

      exclusiveCooldown = true;
      window.clearTimeout(exclusiveCooldownTimer);
      exclusiveCooldownTimer = window.setTimeout(function () {
        exclusiveCooldown = false;
      }, 2500);

      activateReward(triggerLabel, 'exclusive');
    }

    function initPageExclusiveTriggers() {
      var pageHandle = getPageHandle();
      var pageTimer = null;

      if (pageHandle === 'about') {
        var aboutSecret = document.querySelector('.bs-about-page__secret-btn');
        if (!aboutSecret) return;

        var aboutClicks = 0;
        aboutSecret.addEventListener('click', function () {
          aboutClicks += 1;

          window.clearTimeout(pageTimer);
          pageTimer = window.setTimeout(function () {
            aboutClicks = 0;
          }, 2800);

          if (aboutClicks >= 5) {
            aboutClicks = 0;
            activateExclusiveReward('about sigil');
          }
        });
        return;
      }

      if (pageHandle === 'contact') {
        var contactAnchor = document.querySelector('.bs-contact-page__panel-title');
        if (!contactAnchor) return;

        var contactClicks = 0;
        contactAnchor.addEventListener('click', function () {
          contactClicks += 1;

          window.clearTimeout(pageTimer);
          pageTimer = window.setTimeout(function () {
            contactClicks = 0;
          }, 2600);

          if (contactClicks >= 4) {
            contactClicks = 0;
            activateExclusiveReward('hotline cadence');
          }
        });
        return;
      }

      if (pageHandle === 'news') {
        var newsSearchInput = document.querySelector('[data-news-search]');
        if (!newsSearchInput) return;

        newsSearchInput.addEventListener('input', function () {
          var query = String(newsSearchInput.value || '').toLowerCase().trim();
          if (query !== 'wiretap') return;

          activateExclusiveReward('news wiretap');
          newsSearchInput.value = '';

          try {
            newsSearchInput.dispatchEvent(new Event('input', { bubbles: true }));
          } catch (e) {
            var inputEvent = document.createEvent('Event');
            inputEvent.initEvent('input', true, true);
            newsSearchInput.dispatchEvent(inputEvent);
          }
        });
        return;
      }

      if (pageHandle === 'media') {
        var mediaTitle = document.querySelector('.media-header__title');
        if (!mediaTitle) return;

        mediaTitle.addEventListener('click', function (event) {
          if (!event.shiftKey) return;
          activateExclusiveReward('media splice');
        });
        return;
      }

      if (pageHandle === 'services') {
        var serviceStats = document.querySelectorAll('.bs-services__stat-value');
        if (!serviceStats.length) return;

        var touched = {};
        var touchedCount = 0;

        function resetServiceUnlock() {
          touched = {};
          touchedCount = 0;
        }

        for (var statIndex = 0; statIndex < serviceStats.length; statIndex++) {
          (function (index) {
            serviceStats[index].addEventListener('click', function () {
              if (!touched[index]) {
                touched[index] = true;
                touchedCount += 1;
              }

              window.clearTimeout(pageTimer);
              pageTimer = window.setTimeout(resetServiceUnlock, 7000);

              if (touchedCount >= serviceStats.length) {
                resetServiceUnlock();
                activateExclusiveReward('proof loop');
              }
            });
          })(statIndex);
        }
        return;
      }

      if (pageHandle === 'giveaways') {
        var giveawaySteps = document.querySelectorAll('.step-box');
        if (!giveawaySteps.length) return;

        var expectedStep = 0;
        var requiredSteps = Math.min(giveawaySteps.length, 3);

        for (var giveawayIndex = 0; giveawayIndex < giveawaySteps.length; giveawayIndex++) {
          (function (index) {
            giveawaySteps[index].addEventListener('click', function () {
              window.clearTimeout(pageTimer);
              pageTimer = window.setTimeout(function () {
                expectedStep = 0;
              }, 5200);

              if (index === expectedStep) {
                expectedStep += 1;
                if (expectedStep >= requiredSteps) {
                  expectedStep = 0;
                  activateExclusiveReward('lucky route');
                }
                return;
              }

              expectedStep = index === 0 ? 1 : 0;
            });
          })(giveawayIndex);
        }
        return;
      }

      var timeNode = document.querySelector('.bs-home-hub__time, .bs-collection-header__time');
      if (!timeNode) return;

      var timeClicks = 0;
      timeNode.addEventListener('click', function () {
        timeClicks += 1;

        window.clearTimeout(pageTimer);
        pageTimer = window.setTimeout(function () {
          timeClicks = 0;
        }, 2600);

        if (timeClicks >= 4) {
          timeClicks = 0;
          activateExclusiveReward('time fracture');
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      var key = event.key || '';
      var target = event.target;
      var tag = target && target.tagName ? target.tagName.toUpperCase() : '';
      var isEditable = !!(target && (target.isContentEditable || tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT'));

      if (key === konami[konamiIndex]) {
        konamiIndex += 1;
        if (konamiIndex >= konami.length) {
          konamiIndex = 0;
          activateReward('Konami code', 'chaos');
        }
      } else if (key === konami[0]) {
        konamiIndex = 1;
      } else {
        konamiIndex = 0;
      }

      if (isEditable) return;
      if (key.length !== 1 || event.metaKey || event.ctrlKey || event.altKey) return;

      keyBuffer = (keyBuffer + key.toLowerCase()).slice(-24);

      if (keyBuffer.indexOf('berserk') !== -1 || keyBuffer.indexOf('deepcut') !== -1) {
        keyBuffer = '';
        activateReward('keyword signal', 'lore');
      }
    });

    var logoNodes = document.querySelectorAll('.bs-home-hub__logo, .bs-collection-header__logo');
    for (var i = 0; i < logoNodes.length; i++) {
      logoNodes[i].addEventListener('click', function () {
        logoClickCount += 1;

        window.clearTimeout(logoClickResetTimer);
        logoClickResetTimer = window.setTimeout(function () {
          logoClickCount = 0;
        }, 4200);

        if (logoClickCount >= 7) {
          logoClickCount = 0;
          activateReward('logo sigil', 'sigil');
        }
      });
    }

    initPageExclusiveTriggers();
  }

  /**
   * ============================================
   * Navigation Audio
   * ============================================
   */
  function initNavigationAudio() {
    var body = document.body;
    if (!body || typeof window.Audio !== 'function') return;

    var soundsEnabled = body.getAttribute('data-bs-nav-sound-enabled') === 'true';
    var enterSoundUrl = (body.getAttribute('data-bs-nav-enter-sound') || '').trim();
    var backSoundUrl = (body.getAttribute('data-bs-nav-back-sound') || '').trim();
    var historyIndexCounterKey = 'bs_nav_history_index_counter';
    var lastActiveIndexKey = 'bs_nav_last_active_index';
    var currentHistoryIndex = 0;
    var navigationPending = false;
    var soundsPrimed = false;

    if (!soundsEnabled || (!enterSoundUrl && !backSoundUrl)) return;

    currentHistoryIndex = ensureHistoryIndex();

    function ensureHistoryIndex() {
      var state = window.history.state;
      if (state && typeof state.bsNavIndex === 'number') {
        return state.bsNavIndex;
      }

      var nextIndex = 1;

      try {
        nextIndex = parseInt(sessionStorage.getItem(historyIndexCounterKey) || '0', 10) + 1;
        sessionStorage.setItem(historyIndexCounterKey, String(nextIndex));
      } catch (e) {
        nextIndex = new Date().getTime();
      }

      try {
        var nextState = {};
        var key = '';

        if (state && typeof state === 'object') {
          for (key in state) {
            if (Object.prototype.hasOwnProperty.call(state, key)) {
              nextState[key] = state[key];
            }
          }
        }

        nextState.bsNavIndex = nextIndex;
        window.history.replaceState(nextState, document.title, window.location.href);
      } catch (e) {
        // Some browsers restrict history state updates in preview contexts.
      }

      return nextIndex;
    }

    function warmSound(url) {
      if (!url) return;

      try {
        var audio = new Audio(url);
        audio.preload = 'auto';
        audio.load();
      } catch (e) {
        // Ignore preload failures and allow playback attempts later.
      }
    }

    function primeSounds() {
      if (soundsPrimed) return;

      soundsPrimed = true;
      warmSound(enterSoundUrl);
      warmSound(backSoundUrl);
    }

    function startSound(url) {
      if (!url) return null;

      try {
        var audio = new Audio(url);
        audio.preload = 'auto';

        return {
          audio: audio,
          playPromise: audio.play()
        };
      } catch (e) {
        // Ignore playback failures caused by autoplay policies or missing files.
        return null;
      }
    }

    function playSound(url) {
      var playback = startSound(url);

      if (!playback || !playback.playPromise || typeof playback.playPromise.catch !== 'function') {
        return playback;
      }

      playback.playPromise.catch(function () {});
      return playback;
    }

    function navigateWithEnterSound(url) {
      var playback = null;
      var fallbackTimer = 0;
      var hasNavigated = false;

      function finishNavigation() {
        if (hasNavigated) return;

        hasNavigated = true;
        window.clearTimeout(fallbackTimer);
        window.location.assign(url);
      }

      function syncFallbackToDuration() {
        if (!playback || !playback.audio) return;
        if (!isFinite(playback.audio.duration) || playback.audio.duration <= 0) return;

        window.clearTimeout(fallbackTimer);
        fallbackTimer = window.setTimeout(
          finishNavigation,
          Math.min(Math.max(Math.round(playback.audio.duration * 1000) + 40, 220), 1800)
        );
      }

      playback = startSound(enterSoundUrl);

      if (!playback || !playback.audio) {
        finishNavigation();
        return;
      }

      playback.audio.addEventListener('loadedmetadata', syncFallbackToDuration);
      playback.audio.addEventListener('canplaythrough', syncFallbackToDuration);
      playback.audio.addEventListener('ended', finishNavigation);
      playback.audio.addEventListener('error', finishNavigation);
      playback.audio.addEventListener('abort', finishNavigation);

      fallbackTimer = window.setTimeout(finishNavigation, 600);
      syncFallbackToDuration();

      if (playback.playPromise && typeof playback.playPromise.then === 'function') {
        playback.playPromise.then(syncFallbackToDuration).catch(finishNavigation);
      }
    }

    function getNavigationType() {
      var perf = window.performance;
      if (!perf) return '';

      if (typeof perf.getEntriesByType === 'function') {
        var entries = perf.getEntriesByType('navigation');
        if (entries && entries[0] && entries[0].type) {
          return entries[0].type;
        }
      }

      if (perf.navigation && perf.navigation.type === 2) {
        return 'back_forward';
      }

      if (perf.navigation && perf.navigation.type === 1) {
        return 'reload';
      }

      return 'navigate';
    }

    function shouldHandleInternalLink(anchor) {
      if (!anchor || !anchor.href || anchor.hasAttribute('download')) {
        return false;
      }

      if (anchor.hasAttribute('data-no-nav-sound')) {
        return false;
      }

      var target = anchor.getAttribute('target');
      if (target && target.toLowerCase() !== '_self') {
        return false;
      }

      var href = anchor.getAttribute('href') || '';
      if (!href || href.indexOf('#') === 0 || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('javascript:') === 0) {
        return false;
      }

      var destination = null;

      try {
        destination = new URL(anchor.href, window.location.href);
      } catch (e) {
        return false;
      }

      if (destination.origin !== window.location.origin) {
        return false;
      }

      if (
        destination.pathname === window.location.pathname &&
        destination.search === window.location.search &&
        destination.hash
      ) {
        return false;
      }

      if (destination.href === window.location.href) {
        return false;
      }

      return true;
    }

    document.addEventListener('pointerdown', primeSounds, { passive: true });
    document.addEventListener('keydown', primeSounds);

    document.addEventListener('click', function (event) {
      if (!enterSoundUrl || navigationPending || event.defaultPrevented) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!shouldHandleInternalLink(anchor)) return;

      navigationPending = true;
      event.preventDefault();
      navigateWithEnterSound(anchor.href);
    });

    window.addEventListener('pageshow', function (event) {
      var lastActiveIndex = NaN;
      var navigationType = getNavigationType();

      try {
        lastActiveIndex = parseInt(sessionStorage.getItem(lastActiveIndexKey), 10);
      } catch (e) {
        lastActiveIndex = NaN;
      }

      if ((event.persisted || navigationType === 'back_forward') && !isNaN(lastActiveIndex) && currentHistoryIndex < lastActiveIndex) {
        window.setTimeout(function () {
          playSound(backSoundUrl);
        }, 24);
      }

      try {
        sessionStorage.setItem(lastActiveIndexKey, String(currentHistoryIndex));
      } catch (e) {
        // Session storage can be unavailable in strict privacy modes.
      }
    });
  }

  /**
   * ============================================
   * Cart Functions
   * ============================================
   */
  var Cart = {
    /**
     * Add item to cart
     */
    add: function (variantId, quantity, callback) {
      quantity = quantity || 1;
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(data => {
        if (callback) callback(null, data);
      })
      .catch(error => {
        if (callback) callback(error);
      });
    },

    /**
     * Update cart item quantity
     */
    update: function (line, quantity, callback) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(data => {
        if (callback) callback(null, data);
      })
      .catch(error => {
        if (callback) callback(error);
      });
    },

    /**
     * Get current cart state
     */
    get: function (callback) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          if (callback) callback(null, data);
        })
        .catch(error => {
          if (callback) callback(error);
        });
    }
  };

  /**
   * ============================================
   * Quick View Modal
   * ============================================
   */
  var QuickView = {
    modal: null,
    overlay: null,
    currentProductHandle: null,

    init: function () {
      this.createModal();
      this.bindTriggers();
    },

    createModal: function () {
      // Create overlay
      this.overlay = document.createElement('div');
      this.overlay.className = 'quick-view-overlay';
      this.overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.85);z-index:9998;display:none;opacity:0;transition:opacity 300ms ease;';
      document.body.appendChild(this.overlay);

      // Create modal
      this.modal = document.createElement('div');
      this.modal.className = 'quick-view-modal';
      this.modal.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%) scale(0.9);z-index:9999;background:#0a0a0a;border:2px solid rgba(255,255,255,0.1);border-radius:16px;max-width:900px;width:calc(100% - 40px);max-height:90vh;overflow-y:auto;display:none;opacity:0;transition:all 300ms ease;';
      document.body.appendChild(this.modal);

      // Close on overlay click
      this.overlay.addEventListener('click', this.close.bind(this));

      // Close on escape key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          QuickView.close();
        }
      });
    },

    bindTriggers: function () {
      // Listen for quick view button clicks
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('.quick-view-trigger');
        if (!trigger) return;

        e.preventDefault();
        var productHandle = trigger.getAttribute('data-product-handle');
        if (productHandle) {
          QuickView.open(productHandle);
        }
      });
    },

    open: function (productHandle) {
      this.currentProductHandle = productHandle;
      this.overlay.style.display = 'block';
      this.modal.style.display = 'block';
      this.modal.innerHTML = '<div style="padding:60px 40px;text-align:center;color:rgba(255,255,255,0.6);"><div style="width:40px;height:40px;border:3px solid rgba(255,255,255,0.2);border-top-color:#ff1a1a;border-radius:50%;margin:0 auto 20px;animation:spin 0.8s linear infinite;"></div>Loading...</div>';

      // Trigger transitions
      setTimeout(function () {
        QuickView.overlay.style.opacity = '1';
        QuickView.modal.style.opacity = '1';
        QuickView.modal.style.transform = 'translate(-50%,-50%) scale(1)';
      }, 10);

      // Prevent body scroll
      document.body.style.overflow = 'hidden';

      // Fetch product data
      this.fetchProduct(productHandle);
    },

    close: function () {
      this.overlay.style.opacity = '0';
      this.modal.style.opacity = '0';
      this.modal.style.transform = 'translate(-50%,-50%) scale(0.9)';

      setTimeout(function () {
        QuickView.overlay.style.display = 'none';
        QuickView.modal.style.display = 'none';
        document.body.style.overflow = '';
      }, 300);
    },

    fetchProduct: function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (product) {
          QuickView.renderProduct(product);
        })
        .catch(function (error) {
          console.error('Quick View Error:', error);
          QuickView.modal.innerHTML = '<div style="padding:60px 40px;text-align:center;color:rgba(255,68,68,0.8);">Failed to load product</div>';
        });
    },

    renderProduct: function (product) {
      var hasMultipleVariants = product.variants && product.variants.length > 1;
      var selectedVariant = product.variants[0];
      var hasComparePrice = selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price;

      var html = '<div style="position:relative;">';

      // Close button
      html += '<button onclick="window.MinimalistTheme.QuickView.close()" style="position:absolute;top:20px;right:20px;width:40px;height:40px;border:none;background:rgba(255,255,255,0.05);border-radius:50%;color:#fff;font-size:24px;cursor:pointer;z-index:1;transition:all 0.3s ease;" onmouseover="this.style.background=\'rgba(255,255,255,0.1)\'" onmouseout="this.style.background=\'rgba(255,255,255,0.05)\'">×</button>';

      html += '<div style="display:grid;grid-template-columns:1fr 1fr;gap:40px;padding:40px;">';

      // Product Image
      html += '<div>';
      if (product.featured_image) {
        html += '<img src="' + product.featured_image + '" alt="' + this.escapeHtml(product.title) + '" style="width:100%;height:auto;border-radius:12px;border:1px solid rgba(255,255,255,0.08);">';
      }
      html += '</div>';

      // Product Info
      html += '<div>';
      html += '<h2 style="font-size:28px;font-weight:700;color:#fff;margin:0 0 12px;line-height:1.2;">' + this.escapeHtml(product.title) + '</h2>';

      // Price
      html += '<div style="margin-bottom:20px;">';
      if (hasComparePrice) {
        html += '<span style="font-size:24px;font-weight:600;color:#ff1a1a;margin-right:12px;">' + this.formatMoney(selectedVariant.price) + '</span>';
        html += '<span style="font-size:18px;color:rgba(255,255,255,0.4);text-decoration:line-through;">' + this.formatMoney(selectedVariant.compare_at_price) + '</span>';
      } else {
        html += '<span style="font-size:24px;font-weight:600;color:#fff;">' + this.formatMoney(selectedVariant.price) + '</span>';
      }
      html += '</div>';

      // Variant Selector
      if (hasMultipleVariants) {
        html += '<div style="margin-bottom:20px;">';
        html += '<label style="display:block;font-size:14px;font-weight:600;text-transform:uppercase;letter-spacing:0.05em;color:rgba(255,255,255,0.7);margin-bottom:8px;">Select Option</label>';
        html += '<select id="qv-variant-select" style="width:100%;padding:12px 16px;font-size:15px;color:#fff;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:8px;cursor:pointer;">';
        for (var i = 0; i < product.variants.length; i++) {
          var variant = product.variants[i];
          var available = variant.available ? '' : ' (Sold Out)';
          html += '<option value="' + variant.id + '" ' + (i === 0 ? 'selected' : '') + '>' + this.escapeHtml(variant.title) + available + '</option>';
        }
        html += '</select>';
        html += '</div>';
      }

      // Quantity
      html += '<div style="margin-bottom:24px;">';
      html += '<label style="display:block;font-size:14px;font-weight:600;text-transform:uppercase;letter-spacing:0.05em;color:rgba(255,255,255,0.7);margin-bottom:8px;">Quantity</label>';
      html += '<div style="display:flex;align-items:center;gap:12px;max-width:140px;">';
      html += '<button onclick="window.MinimalistTheme.QuickView.changeQuantity(-1)" style="width:40px;height:40px;border:1px solid rgba(255,255,255,0.2);background:rgba(255,255,255,0.05);color:#fff;font-size:18px;border-radius:8px;cursor:pointer;transition:all 0.3s ease;" onmouseover="this.style.background=\'rgba(255,255,255,0.1)\'" onmouseout="this.style.background=\'rgba(255,255,255,0.05)\'">−</button>';
      html += '<input type="number" id="qv-quantity" value="1" min="1" style="width:60px;height:40px;text-align:center;font-size:16px;font-weight:600;color:#fff;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:8px;">';
      html += '<button onclick="window.MinimalistTheme.QuickView.changeQuantity(1)" style="width:40px;height:40px;border:1px solid rgba(255,255,255,0.2);background:rgba(255,255,255,0.05);color:#fff;font-size:18px;border-radius:8px;cursor:pointer;transition:all 0.3s ease;" onmouseover="this.style.background=\'rgba(255,255,255,0.1)\'" onmouseout="this.style.background=\'rgba(255,255,255,0.05)\'">+</button>';
      html += '</div>';
      html += '</div>';

      // Add to Cart Button
      html += '<button onclick="window.MinimalistTheme.QuickView.addToCart()" style="width:100%;padding:16px 32px;font-size:15px;font-weight:600;text-transform:uppercase;letter-spacing:0.05em;color:#000;background:#fff;border:2px solid #fff;border-radius:10px;cursor:pointer;margin-bottom:16px;transition:all 0.3s ease;" onmouseover="this.style.background=\'#ff1a1a\';this.style.borderColor=\'#ff1a1a\';this.style.color=\'#fff\';" onmouseout="this.style.background=\'#fff\';this.style.borderColor=\'#fff\';this.style.color=\'#000\';">Add to Cart</button>';

      // View Full Details Link
      html += '<a href="/products/' + product.handle + '" style="display:block;width:100%;padding:16px 32px;font-size:15px;font-weight:600;text-align:center;text-transform:uppercase;letter-spacing:0.05em;color:#fff;background:transparent;border:2px solid rgba(255,255,255,0.3);border-radius:10px;text-decoration:none;transition:all 0.3s ease;" onmouseover="this.style.borderColor=\'#fff\';" onmouseout="this.style.borderColor=\'rgba(255,255,255,0.3)\';">View Full Details</a>';

      html += '</div>'; // Close product info
      html += '</div>'; // Close grid
      html += '</div>'; // Close container

      // Mobile styles
      html += '<style>@media (max-width: 767px) { .quick-view-modal > div > div { grid-template-columns: 1fr !important; padding: 24px !important; } }</style>';

      this.modal.innerHTML = html;
    },

    changeQuantity: function (delta) {
      var input = document.getElementById('qv-quantity');
      if (!input) return;
      var newVal = parseInt(input.value) + delta;
      if (newVal < 1) newVal = 1;
      input.value = newVal;
    },

    addToCart: function () {
      var variantSelect = document.getElementById('qv-variant-select');
      var quantityInput = document.getElementById('qv-quantity');
      
      var variantId = variantSelect ? parseInt(variantSelect.value) : null;
      var quantity = quantityInput ? parseInt(quantityInput.value) : 1;

      if (!variantId) {
        // If no variant selector, get first variant from current product
        fetch('/products/' + this.currentProductHandle + '.js')
          .then(function (response) { return response.json(); })
          .then(function (product) {
            if (product.variants && product.variants[0]) {
              QuickView.performAddToCart(product.variants[0].id, quantity);
            }
          });
      } else {
        this.performAddToCart(variantId, quantity);
      }
    },

    performAddToCart: function (variantId, quantity) {
      Cart.add(variantId, quantity)
        .then(function () {
          QuickView.close();
          // Optionally reload the page to update cart count
          window.location.href = '/cart';
        })
        .catch(function (error) {
          console.error('Add to cart error:', error);
          alert('Failed to add item to cart. Please try again.');
        });
    },

    formatMoney: function (cents) {
      return '$' + (cents / 100).toFixed(2);
    },

    escapeHtml: function (text) {
      var map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      };
      return text.replace(/[&<>"']/g, function (m) {
        return map[m];
      });
    }
  };

  /**
   * ============================================
   * Initialize All Components
   * ============================================
   */
  function init() {
    initIntroLoader();
    initCollectionHeaderTime();
    initCountdownTimer();
    initDeepCutEasterEggs();
    QuickView.init();
    initNavigationAudio();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose Cart API globally
  window.MinimalistTheme = {
    Cart: Cart,
    QuickView: QuickView
  };

})();
